<template>
  <li class="parts-item-card">
    <PCPartsItemCardHeader
      class="parts-item-card-header"
      :work-part="workPart"
    />

    <PCPartsItemCardBody
      class="parts-item-card-body"
      :work-part="workPart"
    />
  </li>
</template>

<script setup>
// @ts-check
import PCPartsItemCardHeader from './PCPartsItemCardHeader.vue';
import PCPartsItemCardBody from './PCPartsItemCardBody.vue';

/** @import { PropType } from 'vue' */
/** @import { WorkPartItem } from '@/js/stores/repairParts' */

defineProps({
  workPart: {
    /** @type {PropType<WorkPartItem>} */
    type: Object,
    default: null,
  },
});
</script>

<style scoped lang="scss">
.parts-item-card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;

  .parts-item-card-header,
  .parts-item-card-body {
    padding: var(--f7-typography-padding);
  }
}
</style>
